import { render } from "./bulk-customers-upload.vue?vue&type=template&id=4db3385e&scoped=true"
import script from "./bulk-customers-upload.vue?vue&type=script&lang=js"
export * from "./bulk-customers-upload.vue?vue&type=script&lang=js"

import "./bulk-customers-upload.vue?vue&type=style&index=0&id=4db3385e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db3385e"]])

export default __exports__